import { Dispatch } from "react";
import { Action } from "../types";
import { MAP_TYPE_IDS } from "../../components/FlotiMap/data";

export type SimpleFleet = {
  fleetid: number
  name: string
}

export enum PreferenceKey {
  SELECTED_DASHBOARDS = 'SELECTED_DASHBOARDS',
  SELECTED_FLEET = 'SELECTED_FLEET',
  LANGUAGE = 'LANGUAGE',
  MOBILE_OR_DRIVER = 'MOBILE_OR_DRIVER',
  SELECTED_DRIVER = 'SELECTED_DRIVER',
  SELECTED_MOBILE = 'SELECTED_MOBILE',
  BASELAYER = 'BASELAYER',
  SELECTED_LAYERS = 'SELECTED_LAYERS',
  ENABLE_CLUSTER = 'ENABLE_CLUSTER',
  DEFAULT_LANDING_SITE = 'DEFAULT_LANDING_SITE',
  SELECTED_ROUTE = 'SELECTED_ROUTE',
  MAP_FULLSCREEN_ON_LOAD = 'MAP_CULLSCREEN_ON_LOAD',
  EMAIL_ON_POSREP_FAILURE	= 'EMAIL_ON_POSREP_FAILURE',
  MAP_ZOOM_LEVEL_ON_LOAD = 'MAP_ZOOM_LEVEL_ON_LOAD',
  MAP_LATITUDE_ON_LOAD = 'MAP_LATITUDE_ON_LOAD',
  MAP_LONGITUDE_ON_LOAD	= 'MAP_LONGITUDE_ON_LOAD',
  CUSTOM_STOP_LIMIT	= 'CUSTOM_STOP_LIMIT',
  HIDE_STOPS_HISTORY = 'HIDE_STOPS_HISTORY',
  DISABLE_ZOOM_AND_DRAG	= 'DISABLE_ZOOM_AND_DRAG',
  SHOW_LIVECAMS = 'SHOW_LIVECAMS',
  SHOW_ROAD_CONDITIONS = 'SHOW_ROAD_CONDITIONS',
  SHOW_WEATHER = 'SHOW_WEATHER',
  FLEETLIST_PAGE_LENGTH = 'FLEETLIST_PAGE_LENGTH'
}

export type Preference = {
  [PreferenceKey.DEFAULT_LANDING_SITE]: string
  [PreferenceKey.CUSTOM_STOP_LIMIT]: number
  [PreferenceKey.DISABLE_ZOOM_AND_DRAG]: boolean
  [PreferenceKey.HIDE_STOPS_HISTORY]: boolean
  [PreferenceKey.MAP_FULLSCREEN_ON_LOAD]: boolean
  [PreferenceKey.MAP_LATITUDE_ON_LOAD]: number
  [PreferenceKey.MAP_LONGITUDE_ON_LOAD]: number
  [PreferenceKey.MAP_ZOOM_LEVEL_ON_LOAD]: number
  [PreferenceKey.SELECTED_FLEET]: number
  [PreferenceKey.SELECTED_MOBILE]: number
  [PreferenceKey.BASELAYER]: MAP_TYPE_IDS
  [PreferenceKey.ENABLE_CLUSTER]: boolean
  [PreferenceKey.LANGUAGE]: string
  [PreferenceKey.FLEETLIST_PAGE_LENGTH]: number
  [PreferenceKey.SHOW_LIVECAMS]: boolean
  [PreferenceKey.SHOW_ROAD_CONDITIONS]: boolean
  [PreferenceKey.SHOW_LIVECAMS]: boolean
  [PreferenceKey.SHOW_WEATHER]: boolean
}

export enum PreferencePatchKey {
  SELECTED_DASHBOARDS = 'selected_dashboards',
  SELECTED_FLEET = 'selected_fleet',
  LANGUAGE = 'language',
  MOBILE_OR_DRIVER = 'mobile_or_driver',
  SELECTED_DRIVER = 'selected_driver',
  SELECTED_MOBILE = 'selected_mobile',
  BASELAYER = 'baselayer',
  SELECTED_LAYERS = 'selected_layers',
  ENABLE_CLUSTER = 'enable_cluster',
  DEFAULT_LANDING_SITE = 'default_landing_site',
  SELECTED_ROUTE = 'selected_route',
  MAP_FULLSCREEN_ON_LOAD = 'map_fullscreen_on_load',
  EMAIL_ON_POSREP_FAILURE	= 'email_on_posrep_failure',
  MAP_ZOOM_LEVEL_ON_LOAD = 'map_zoom_level_on_load',
  MAP_LATITUDE_ON_LOAD = 'map_latitude_on_load',
  MAP_LONGITUDE_ON_LOAD	= 'map_longitude_on_load',
  CUSTOM_STOP_LIMIT	= 'custom_stop_limit',
  HIDE_STOPS_HISTORY = 'hide_stops_history',
  DISABLE_ZOOM_AND_DRAG	= 'disable_zoom_and_drag',
  SHOW_LIVECAMS = 'show_livecams',
  SHOW_ROAD_CONDITIONS = 'show_road_conditions',
  SHOW_WEATHER = 'show_weather',
  FLEETLIST_PAGE_LENGTH = 'fleetlist_page_length'
}

type Permissions = {
  trackwell?: Record<string, boolean>
  auth?: Record<string, boolean>
  fleet?: Record<string, boolean>
}

export type UserState = {
  name: string
  username: string
  id: string
  first_name: string
  last_name: string
  initialized: false
  access_token?: string
  refresh_token?: string
  language: string
  groups: string[]
  permissions: Permissions
  main_fleet?: number
  email?: string
  available_fleets: SimpleFleet[]
  preferences?: Preference
}

export type Token = {
  refresh: string
  access: string
}

export type User = {
  name: string
  username: string
  first_name: string
  last_name: string
  language: string
  groups: string[]
  permissions: Permissions
  main_fleet?: number
  email?: string
}

export type UserContext = {
  user: UserState
  dispatch: Dispatch<Action>
}
